<div class="password-container">
  <input [type]="showPassword ? 'text' : 'password'" class="text-input" [placeholder]="placeholder"
    name="password" (input)="registerOnChange($event.target.value)" [required]="required" [minLength]="minLength">
  <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' :'fa-eye'" (click)="showPassword = !showPassword"></i>
</div>
